.container {
  padding: 1.6rem;
  min-width: 32rem;
  max-width: 100%;
}
